export default __webpack_public_path__ + "static/media/12.275c8274.png";